import { DriverErrorType } from '@fluidframework/driver-definitions';
import { MfsError, MfsStatusCode } from '@metaos/mfs-telemetry';
/** ODSP Drive Error custom class */
export class MfsOdspDriverError extends MfsError {
    constructor(odspDriverErrorType) {
        super(`ODSP Driver Error when mounting pod`, getErrorCode(odspDriverErrorType));
        this.odspDriverErrorType = odspDriverErrorType;
    }
}
/** Get MfsStatusCode from odspDriverErrorType */
function getErrorCode(odspDriverErrorType) {
    switch (odspDriverErrorType) {
        case DriverErrorType.authorizationError:
            return MfsStatusCode.Unauthorized;
        case DriverErrorType.deltaStreamConnectionForbidden:
            return MfsStatusCode.Forbidden;
        case DriverErrorType.fetchFailure:
            return MfsStatusCode.UnhandledException;
        case DriverErrorType.fileOverwrittenInStorage:
            return MfsStatusCode.DataCorruption;
        case DriverErrorType.genericNetworkError:
            return MfsStatusCode.UnhandledException;
        case DriverErrorType.incorrectServerResponse:
            return MfsStatusCode.UnhandledException;
        case DriverErrorType.offlineError:
            return MfsStatusCode.UnhandledException;
        case DriverErrorType.throttlingError:
            return MfsStatusCode.TooManyRequests;
        case DriverErrorType.unsupportedClientProtocolVersion:
            return MfsStatusCode.NotAllowed;
        case DriverErrorType.writeError:
            return MfsStatusCode.UnhandledException;
        default:
            return MfsStatusCode.UnhandledException;
    }
}
//# sourceMappingURL=customErrors.js.map